export default "__VITE_ASSET__CMYjpvjo__"